var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-search sidebar"},[_c('SearchAmendment'),_c('RplDivider'),_c('Filters')],1)}
var staticRenderFns = []

export { render, staticRenderFns }